import { render, staticRenderFns } from "./AboutContract.vue?vue&type=template&id=6e855086&scoped=true"
import script from "./AboutContract.vue?vue&type=script&lang=js"
export * from "./AboutContract.vue?vue&type=script&lang=js"
import style0 from "./AboutContract.vue?vue&type=style&index=0&id=6e855086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e855086",
  null
  
)

export default component.exports